"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  DELIVERY_FAILED: null,
  DELIVERY_PENDING_AND_POLLING_STATUS: null,
  DELIVERY_PENDING_AND_NOT_POLLING_STATUS: null,
  DELIVERY_SUCCEEDED_BEFORE_LAST_PAGE_LOAD: null,
  DELIVERY_SUCCEEDED_CONFIRMED_BY_POLLING: null,
  UNINSTALLED: null,
  REFUNDED: null
});

exports.default = _default;
module.exports = exports.default;